/**
 * SchemaConfigForm - Schema configuration form
 * @module components/starnexus/wizard/forms/SchemaConfigForm
 *
 */

import React from 'react';
import Table from '@amzn/awsui-components-console/table';
import Badge from '@amzn/awsui-components-console/badge';
import Header from '@amzn/awsui-components-console/header';
import Box from '@amzn/awsui-components-console/box';
import type { SchemaColumn } from '../../../../types/starnexus';

interface SchemaConfigFormProps {
  schema: SchemaColumn[];
  onChange: (schema: SchemaColumn[]) => void;
  onRegenerate?: () => void;
}

export const SchemaConfigForm: React.FC<SchemaConfigFormProps> = ({ schema }) => {
  const columnDefinitions = [
    {
      id: 'columnName',
      header: 'Column Name',
      cell: (item: SchemaColumn) => <Box fontWeight="bold">{item.columnName}</Box>,
      width: 180,
    },
    {
      id: 'dataType',
      header: 'Data Type',
      cell: (item: SchemaColumn) => <Badge color="blue">{item.dataType}</Badge>,
      width: 120,
    },
    {
      id: 'nullable',
      header: 'Nullable',
      cell: (item: SchemaColumn) => item.nullable ? 'Yes' : 'No',
      width: 80,
    },
    {
      id: 'sampleValues',
      header: 'Sample Values',
      cell: (item: SchemaColumn) => (
        <Box color="text-body-secondary">{item.sampleValues.slice(0, 3).join(', ')}</Box>
      ),
    },
  ];

  return (
    <Table
      columnDefinitions={columnDefinitions}
      items={schema}
      variant="embedded"
      header={<Header description="Auto-detected from uploaded file. Use SQL Transform to reshape output.">Source schema ({schema.length} columns)</Header>}
      empty={
        <Box textAlign="center" color="inherit">
          <b>No columns detected</b>
          <Box variant="p" color="inherit">Upload a sample file to detect schema.</Box>
        </Box>
      }
    />
  );
};

export default SchemaConfigForm;
